var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "card_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.363 4H5.333c-1.65 0-3 1.35-3 3v10c0 1.65 1.35 3 3 3h14.03c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3M5.333 6h14.03c.55 0 1 .45 1 1v1H4.333V7c0-.55.45-1 1-1m14.03 12H5.333c-.55 0-1-.45-1-1v-7h16.03v7c0 .55-.45 1-1 1",
  clipRule: "evenodd"
})));
export default SvgCard;